module.exports = __webpack_public_path__ + "static/media/hamburger-menu.3a46578a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hamburger-menu.svg
// module id = 1416
// module chunks = 0